import {
  Box,
  BoxProps,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { theme } from 'theme';



export type DocumentPaneCardProps = {
  id: string;
  title: string;
  createdBy: string;
  updatedAt: string;
  createdAt: string;
};

type IFieldNames = Exclude<keyof DocumentPaneCardProps, 'id'>;

const fieldName2Label: Record<IFieldNames, string> = {
  title: 'Title',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  createdBy: 'Created by'
};

const fieldName2Icon: Record<IFieldNames, () => ReactNode> = {
  title: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />,
  createdAt: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />,
  updatedAt: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />,
  createdBy: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />
};



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DocumentPaneCardProps & BoxProps) => {

  const location = useLocation();

  const handleClick = (id: string, location: string) => {
    const parts = location.split('/plans');
    const url = `${parts[0]}/files/${id}`;

    window.open(url, '_blank');
  };
  return (
    <Card
      onClick={() => handleClick(props.id, location.pathname)}
      sx={{
        borderRadius: '20px',
        flex: '1 -1 0',
        minWidth: '300px',
        minHeight: '10rem'
      }}
      id={props.id}
    >
      <CardHeader
        sx={{
          bgcolor: '#10B99F',
          color: '#FFFFFF'
        }}
        title={props.title}
      />
      <CardContent>
        <Stack
          direction='row'
        >
          <Box>
            <Typography
              variant='modalTitle'
            >
              {props.title}
            </Typography>
          </Box>
        </Stack>

        {DocumentCardFieldRow('createdBy', props.createdBy)}
        {DocumentCardFieldRow('updatedAt', props.updatedAt)}
        {DocumentCardFieldRow('createdAt', props.createdAt)}

      </CardContent>

    </Card>
  );
};


const DocumentCardFieldRow = (fieldName: IFieldNames, value: string) => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      columnGap='1rem'
    >
      {fieldName2Icon[fieldName]()}
      <Typography
        variant='displayFieldLabel'
      >
        {fieldName2Label[fieldName]}
      </Typography>
      <Typography
        variant='displayFieldValue'
      >
        {value}
      </Typography>
    </Stack>
  );
};

